import React from "react";
import { Container, Eyebrow } from "@/components/primitives";
import { Reveal } from "@/components/Reveal";
import { CTASection } from "@/components/sections";

export const LegalPage = ({ eyebrow, title, updated, intro, sections }) => (
  <>
    <section className="pt-36 pb-12 sm:pt-44">
      <Container className="max-w-3xl">
        <Reveal><Eyebrow>{eyebrow}</Eyebrow></Reveal>
        <Reveal delay={0.08}>
          <h1 className="mt-5 font-heading text-5xl font-light leading-[0.98] tracking-tight text-[var(--fg)] sm:text-6xl text-balance">{title}</h1>
        </Reveal>
        {updated && <p className="mt-6 font-mono text-xs uppercase tracking-[0.14em] text-[var(--muted-fg)]">Last updated · {updated}</p>}
        {intro && <p className="mt-6 text-base font-light leading-relaxed text-[var(--muted-fg)]">{intro}</p>}
      </Container>
    </section>

    <section className="pb-24 sm:pb-32">
      <Container className="max-w-3xl">
        <div className="space-y-12">
          {sections.map((s, i) => (
            <Reveal key={i} delay={0.03 * i}>
              <div>
                <h2 className="font-heading text-2xl font-normal tracking-tight text-[var(--fg)] sm:text-3xl">{s.h}</h2>
                <div className="mt-4 space-y-4">
                  {s.p.map((para, j) => (
                    <p key={j} className="text-sm leading-relaxed text-[var(--muted-fg)] sm:text-base">{para}</p>
                  ))}
                  {s.list && (
                    <ul className="mt-2 space-y-2 pl-1">
                      {s.list.map((li, k) => (
                        <li key={k} className="flex gap-3 text-sm leading-relaxed text-[var(--muted-fg)] sm:text-base">
                          <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[var(--primary)]" />{li}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>

    <CTASection eyebrow="Questions?" title="We're happy to explain anything." />
  </>
);
